export const getFileNameDisplay = (
  minimal: boolean,
  imageSrc: string,
  defaultPreviewDeleted?: boolean,
): boolean => {
  if (defaultPreviewDeleted) {
    return true;
  }
  if (minimal) {
    return true;
  }
  if (!imageSrc) {
    return true;
  }
  return false;
};
